export enum AuthStatus {
  None,
  Metamask,
  Full,
}
